// Timings that exist to outlast a transition somewhere else (a smooth scroll, a
// MUI accordion expand). Named and shared so they are visible when those
// durations change, rather than being two near-identical magic numbers.
export const SCROLL_SETTLE_MS = 320;
export const ACCORDION_SETTLE_MS = 340;
// Cap on waiting for a sliding panel's box to hold still (MUI drawer ~225ms).
export const PANEL_STILL_TIMEOUT_MS = 1500;
